import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { CapricornCreateCsvComponent } from './capricorn.create-csv.component';
import { CapricornService }            from './capricorn.service';
import { CapricornSettingsComponent }  from './capricorn.settings.component';
import { CapricornStates }             from './capricorn.states';
import { SharedModule }                from '../shared/shared.module';

@NgModule({
  declarations: [
    CapricornCreateCsvComponent,
    CapricornSettingsComponent
  ],
  entryComponents: [
    CapricornCreateCsvComponent,
    CapricornSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: CapricornStates })
  ],
  providers: [
    CapricornService
  ]
})
export class CapricornModule {}
